import {NgModule} from '@angular/core';

import {SharedModule} from '../shared/shared.module';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {UserPreferredProductsComponent} from './components/user-preferred-products/user-preferred-products.component';
import {UserPreferredProductsRoutingModule} from './user-preferred-products-routing.module';

const MODULES = [SharedModule, UserPreferredProductsRoutingModule];

const COMPONENTS = [UserPreferredProductsComponent];

const SERVICES = [];

@NgModule({
    imports: [...MODULES, CarouselModule, LazyLoadImageModule],
    providers: [...SERVICES],
    declarations: [...COMPONENTS]
})
export class UserPreferredProductsModule {
}
